import React, { useMemo } from 'react';
import SelectWeb, { components, Props as SelectProps } from 'react-select';
import { Col, IColProps } from 'components';
import { COLOR } from 'const';
import AsyncSelect, { useAsync } from 'react-select/async';
import countryList from 'react-select-country-list';
import ReactCountryFlag from "react-country-flag";
var languages = require('language-list');

interface ISelectProps extends IColProps {
  required?: boolean,
  value: any,
  onChange: any,
  options?: Array<any>,
  styles?: any,
  noBorder?: boolean,
  borderColor?: string,
  placeholder?: string,
  isMulti?: boolean,
  innerProps?: SelectProps,
  loadOptions?: any,
  defaultOptions?: Array<any>,
  formatOptionLabel?: any,
  [additionProp: string]: any,
}

const Select = ({ value, onChange, options, styles, noBorder, isMulti, innerProps, loadOptions, defaultOptions, borderColor, placeholder, formatOptionLabel, ...props }: ISelectProps) => {
  const height =  props.height ? { height: isMulti ? 'auto' : props.height, minHeight: isMulti ? 'auto' : props.height } : {};
  const SelectComponent = !!loadOptions ? AsyncSelect : SelectWeb;
  const handleInputChange = !loadOptions ? undefined : (newValue) => {

  };
  return (
    <Col {...props}>
      <SelectComponent
        value={value}
        onChange={onChange}
        options={options}
        isMulti={isMulti}
        defaultOptions={defaultOptions}
        loadOptions={loadOptions}
        onInputChange={handleInputChange}
        placeholder={placeholder}
        styles={{
          control: (style) => ({
            ...style,
            height: isMulti ? 'auto' : 40,
            minHeight: 40,
            borderRadius: 8,
            backgroundColor: 'transparent',
            borderColor: noBorder ? 'transparent' : borderColor || COLOR.BORDER,
            boxShadow: 'none',
            '&:hover': {
              borderColor: noBorder ? 'transparent' : borderColor || COLOR.BORDER,
            },
            ...height,
          }),
          input: styles => ({ ...styles, outline: 'none', ...height, }),
          indicatorSeparator: (style) => ({ display: 'none' }),
          placeholder: (style) => ({
            ...style,
            fontSize: 14,
            color: COLOR.FONT,
          }),
          valueContainer: (provided, state) => ({
            ...provided,
            ...height,
          }),
          indicatorsContainer: (provided, state) => ({
            ...provided,
            ...height,
          }),
          ...props.styles,
        }}
        menuPortalTarget={document.querySelector('body')}
        formatOptionLabel={formatOptionLabel}
        {...innerProps}
      />
    </Col>
  )
}

export const Select01 = (props : ISelectProps) => {
  return (
    <Select
      noBorder
      backgroundColor={COLOR.GREY_LIGHT}
      borderRadius={4}
      {...props}
    />
  )
}

export const Select02 = (props : ISelectProps) => {
  return (
    <Select
      borderRadius={4}
      height={45}
      borderColor={'rgba(0,0,0,0.3)'}
      {...props}
    />
  )
}

export const SelectCountry = (props : ISelectProps) => {

  const coiuntryOptions = useMemo(() => countryList().getData(), []);
  return (
    <Select
      noBorder
      backgroundColor={'white'}
      borderRadius={4}
      options={coiuntryOptions}
      formatOptionLabel={country => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <ReactCountryFlag countryCode={country.value} svg />
          <span>{country.label}</span>
        </div>
      )}
      {...props}
    />
  )
}

interface ISelectLanguageProps extends ISelectProps {
  currentOptions?: Array<string>
}

export const SelectLanguage = (props : ISelectLanguageProps) => {

  const fullLangOptions = useMemo(() => {
    return SelectLanguage.fullLangOptions;
  }, []);

  const matchLangCodeToCountryCode = (langCode: string) => {
    if (langCode === 'en') return 'gb';
    if (langCode === 'zh') return 'cn';
    if (langCode === 'pt') return 'pt';
    if (langCode === 'es') return 'es';
    return langCode
  }

  const currentOptions = useMemo(() => {
    if (!props.currentOptions) return fullLangOptions
    const arr = [];
    props.currentOptions.forEach(value => {
      const find = fullLangOptions.find(v => v.value === value);
      if (find) arr.push(find);
    });
    return arr;
  }, [fullLangOptions, props.currentOptions]);
  // console.log(languages.getData());
  return (
    <Select
      noBorder
      backgroundColor={'white'}
      borderRadius={4}
      options={currentOptions}
      formatOptionLabel={country => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <ReactCountryFlag countryCode={matchLangCodeToCountryCode(country.value)} svg />
          <span>{country.label}</span>
        </div>
      )}
      {...props}
    />
  )
}

SelectLanguage.fullLangOptions = (() => {
  const list = languages().getData().map(v => ({
    label: v.language,
    value: v.code,
  }));

  const priority = [
    'en', 'es', 'fr', 'de',
    'it', 'pt', 'ru', 'zh',
  ];
  const listWithPriority = [];
  priority.forEach(p => {
    const found = list.find(l => l.value === p);
    if (found) {
      listWithPriority.push(found);
    }
  });
  list.forEach(l => {
    if (!priority.includes(l.value)) {
      listWithPriority.push(l);
    }
  });
  return listWithPriority;
})();

export default Select;